import Vue from "vue";
import Router from "vue-router";

import AccessActions from "./components/pages/accessActions.vue";
import AccessControls from "./components/pages/accessControls.vue";
import AccessPermission from "./components/pages/accessPermission.vue";
import AccessPermissions from "./components/pages/accessPermissions.vue";
import AccessQuick from "./components/pages/accessQuick.vue";
import AccountsPayableCategory from "./components/pages/AccountsPayableCategory.vue";
import AccountsPayableConciliation from "./components/pages/AccountsPayableConciliation.vue";
import AccountsReceivableConciliation from "./components/pages/AccountsReceivableConciliation.vue";
import AccountsReceivableCategory from "./components/pages/AccountsReceivable/AccountsReceivableCategory.vue";
import AdvancePaymentOperations from "./components/pages/advancePaymentOperations.vue";
import AdvancePayments from "./components/pages/advancePayments.vue";
import Agencies from "./components/pages/agencies.vue";
import Answers from "./components/pages/answers.vue";
import Areas from "./components/pages/areas.vue";
import Banks from "./components/pages/banks.vue";
import Nichos from "./components/pages/nichos.vue";
import Segmentos from "./components/pages/segmentos.vue";
import BankAccount from "./components/pages/BankAccount/BankAccount.vue";
import RegistrationsBankAccount from "./components/pages/RegistrationsBankAccount.vue";
import BankConciliation from "./components/pages/BankConciliation/BankConciliation.vue";
import BlockLists from "./components/pages/BlockLists.vue";
import BusinessDashboard from "./components/pages/businessDashboard.vue";
import BankStatement from "./components/pages/BankStatement";
import Calculator from "./components/pages/calculator.vue";
import CashFlow from "./components/pages/CashFlow.vue";
import ChangeAccess from "./components/pages/changeAccess.vue";
import ChangeManagement from "./components/pages/changeManagement.vue";
import ChangePassword from "./components/pages/changePassword.vue";
import CheckingAccount from "./components/pages/checkingAccount.vue";
import CheckingAccountDetails from "./components/pages/checkingAccountDetails.vue";
import CheckingAccountMerchants from "./components/pages/checkingAccountMerchants.vue";
import Cities from "./components/pages/cities.vue";
import Commissions from "./components/pages/commissions.vue";
import ConfigurationTaxes from "./components/pages/configurationTaxes.vue";
import ConsultDDA from "./components/pages/ConsultDDA/ConsultDDA.vue";
import Countries from "./components/pages/countries.vue";
import CreditBureau from "./components/pages/creditBureau.vue";
import CustomerService from "./components/pages/CustomerService/CustomerService.vue";
import CustomerServiceCategory from "./components/pages/CustomerServiceCategory/CustomerServiceCategory.vue";
import ParceiroAtendimentoCategoria from "./components/pages/ParceiroAtendimentoCategoria/ParceiroAtendimentoCategoria.vue";
import Documents from "./components/pages/documents.vue";
import Brand from "./components/pages/brand.vue";
import DoublePayment from "./components/pages/DoublePayment/DoublePayment.vue";
import Downloads from "./components/pages/downloads.vue";
import Email from "./components/pages/email.vue";
import Emailage from "./components/pages/emailage.vue";
import Emailing from "./components/pages/emailing.vue";
import Errors from "./components/pages/errors.vue";
import FieldTypes from "./components/pages/fieldTypes.vue";
import Fields from "./components/pages/fields.vue";
import FinancialAudit from "./components/pages/financialAudit.vue";
import FinancialDashboard from "./components/pages/financialDashboard.vue";
import FinancialView from "./components/pages/FinancialView/FinancialView.vue";
import Functionality from "./components/pages/Functionality.vue";
import Chargeback from "./components/pages/chargeback.vue";
import ChargebackDashboard from "./components/pages/chargebackDashboard.vue";
import ChargebackBrand from "./components/pages/chargebackBrand.vue";
import ChargebacksMarketplaceDashboard from "./components/pages/chargebacksMarketplaceDashboard.vue";
import ChargebackMarketplace from "./components/pages/chargebacksMarketplace.vue";
import ForgotPassword from "./components/pages/forgotPassword.vue";
import Forms from "./components/pages/forms.vue";
import Gateways from "./components/pages/gateways.vue";
import SpecieTypes from "./components/pages/specieTypes.vue";
import HealthChecks from "./components/pages/healthChecks.vue";
import Holidays from "./components/pages/Holidays/Holidays.vue";
import Login from "./components/pages/login.vue";
import Limits from "./components/pages/limits.vue";
import Parameters from "./components/pages/Parameters/Parameters.vue";
import MarketplaceDashboard from "./components/pages/marketplaceDashboard.vue";
import Marketplaces from "./components/pages/marketplaces.vue";
import MerchantCampaigns from "./components/pages/merchantCampaigns.vue";
import MerchantCheckingAccount from "./components/pages/merchantCheckingAccount.vue";
import MerchantCheckingAccountDetail from "./components/pages/MerchantCheckingAccountDetail.vue";
import MerchantContracts from "./components/pages/merchantContracts.vue";
import MerchantDocs from "./components/pages/merchantDocs.vue";
import MerchantDocType from "./components/pages/merchantDocType.vue";
import MerchantLimits from "./components/pages/merchantLimits.vue";
import MerchantHistory from "./components/pages/merchantHistory.vue";
import MerchantMetrics from "./components/pages/merchantMetrics.vue";
import MerchantNotes from "./components/pages/merchantNotes.vue";
import MerchantNotification from "./components/pages/MerchantNotification/MerchantNotification.vue";
import MerchantNotTransacting from "./components/pages/merchantNotTransacting.vue";
import MerchantNotTransactingCommercial from "./components/pages/merchantNotTransactingCommercial.vue";
import Merchants from "./components/pages/merchants.vue";
import MerchantPlan from "./components/pages/merchantPlan.vue";
import MerchantSolicitations from "./components/pages/merchantSolicitations.vue";
import MensalidadeIsencao from "./components/pages/MensalidadeIsencao/MensalidadeIsencao.vue";
import LancamentoManual from "./components/pages/LancamentoManual/LancamentoManual.vue";
import MerchantSubscription from "./components/pages/MerchantSubscription/MerchantSubscription.vue";
import MerchantTransaction from "./components/pages/MerchantTransaction/MerchantTransaction.vue";
import MerchantTrainings from "./components/pages/merchantTrainings.vue";
import MerchantUser from "./components/pages/MerchantUser/MerchantUser.vue";
import MerchantPreview from "./components/pages/MerchantPreview/MerchantPreview.vue";
import Negotiation from "./components/pages/Negotiation/Negotiation.vue";
import NoteExtractPartners from "./components/pages/NoteExtractPartners.vue";
import NoteExtracts from "./components/pages/NoteExtracts.vue";
import Okrs from "./components/pages/okrs.vue";
import Operators from "./components/pages/operators.vue";
import OperadoresDetalhes from "./components/pages/OperadoresDetalhes.vue";
import AccountsPayable from "./components/pages/AccountsPayable/accountspayable.vue";
import AccountsReceivable from "./components/pages/AccountsReceivable/accountsreceivable.vue";
import ParceiroAtendimento from "./components/pages/ParceiroAtendimento/ParceiroAtendimento.vue";
import ParceiroAtendimentoIdParceiro from "./components/pages/ParceiroAtendimentoIdParceiro/ParceiroAtendimentoIdParceiro.vue";
import PartnerCommission from "./components/pages/partnerCommission.vue";
import PartnerCommissions from "./components/pages/partnerCommissions.vue";
import PartnerContracts from "./components/pages/partnerContracts.vue";
import PartnerDocs from "./components/pages/partnerdocs.vue";
import PartnerDocTypes from "./components/pages/partnerDocTypes.vue";
import Partners from "./components/pages/partners.vue";
import PartnerTrainings from "./components/pages/partnerTrainings.vue";
import Payments from "./components/pages/payments.vue";
import Profit from "./components/pages/profit.vue";
import Profits from "./components/pages/profits.vue";
import ProspectHistories from "./components/pages/prospectHistories.vue";
import Prospects from "./components/pages/prospects.vue";
import ProspectTrainings from "./components/pages/prospectTrainings.vue";
import Questions from "./components/pages/questions.vue";
import ResetPassword from "./components/pages/resetPassword.vue";
import RegisterType from "./components/pages/registerType.vue";
import SellerMetrics from "./components/pages/sellerMetrics.vue";
import CompositionFeeType from "./components/pages/compositionFeeType.vue";
import Services from "./components/pages/services.vue";
import ServiceType from "./components/pages/serviceType.vue";
import Shortener from "./components/pages/shortener.vue";
import Signatures from "./components/pages/signatures.vue";
import States from "./components/pages/states.vue";
import SuspectTransaction from "./components/pages/suspectTransaction.vue";
import TransactionCharge from "./components/pages/TransactionCharge/TransactionCharge.vue";
import TransferBankAccounts from "./components/pages/transferBankAccounts.vue";
import TransferRegister from "./components/pages/transferRegister.vue";
import TemplateEmail from "./components/pages/templateEmail.vue";
import TemplateEmails from "./components/pages/templateEmails.vue";
import Transaction from "./components/pages/Transaction/Transaction.vue";
import Tickets from "./components/pages/tickets.vue";
import TrainingImprovements from "./components/pages/trainingImprovements.vue";
import UserProfile from "./components/pages/userProfile.vue";
import Users from "./components/pages/users.vue";
import WatcherType from "./components/pages/watcherTypes.vue";
import Watchers from "./components/pages/watchers.vue";
import Provider from "./components/pages/Financial/Provider/Provider.vue";
import TransactionCreditCardRefused from "./components/pages/TransactionCreditCardRefused/TransactionCreditCardRefused.vue";
import PixDiretoEmConta from "./components/pages/PixDiretoEmConta/PixDiretoEmConta.vue";
import TransferenciaRecusada from "./components/pages/transferenciaRecusada.vue";
import AlertasMerchant from "./components/pages/Compliance/AlertasMerchant.vue";
import MerchantMaquina from "./components/pages/Maquina/MerchantMaquina.vue";
import Maquina from "./components/pages/Maquina/Maquina.vue";
import SingleSale from "./components/pages/SingleSale/SingleSale.vue";
import CategoriasDosFornecedores from "./components/pages/CategoriasDosFornecedores/CategoriasDosFornecedores.vue";
import ContactCategory from "./components/pages/ContactCategory/ContactCategory.vue";
import MerchantContact from "./components/pages/MerchantContact/merchantContact.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "login",
      meta: { layout: "default" },
      component: Login
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      meta: { layout: "default" },
      component: ForgotPassword
    },
    {
      path: "/reset-password",
      name: "reset-password",
      meta: { layout: "default" },
      component: ResetPassword
    },
    {
      path: "/access-quick",
      name: "access-quick",
      meta: { layout: "header-navigation" },
      component: AccessQuick
    },
    {
      path: "/deals/business-dashboard",
      name: "business-dashboard",
      meta: { layout: "header-navigation" },
      component: BusinessDashboard
    },
    {
      path: "/deals/marketplace-dashboard",
      name: "marketplace-dashboard",
      meta: { layout: "header-navigation" },
      component: MarketplaceDashboard
    },
    {
      path: "/deals/marketplace-dashboard/marketplaces",
      name: "marketplaces",
      meta: { layout: "header-navigation" },
      component: Marketplaces
    },
    {
      path: "/deals/prospects",
      name: "prospects",
      meta: { layout: "header-navigation" },
      component: Prospects
    },
    {
      path: "/deals/merchantmaquina",
      name: "merchantmaquina",
      meta: { layout: "header-navigation" },
      component: MerchantMaquina
    },
    {
      path: "/deals/maquina",
      name: "maquina",
      meta: { layout: "header-navigation" },
      component: Maquina
    },
    {
      path: "/deals/prospects/prospect-trainings/:idProspect",
      name: "prospect-trainings",
      meta: { layout: "header-navigation" },
      component: ProspectTrainings
    },
    {
      path: "/deals/clients",
      name: "merchants",
      meta: { layout: "header-navigation" },
      component: Merchants
    },
    {
      path: "/deals/clients/merchant-history/:idMerchant",
      name: "merchant-history",
      meta: { layout: "header-navigation" },
      component: MerchantHistory
    },
    {
      path: "/deals/clients/merchant-subscription/:idMerchant",
      name: "merchant-subscription",
      meta: { layout: "header-navigation" },
      component: MerchantSubscription
    },
    {
      path: "/deals/clients/merchant-transaction/:idMerchant",
      name: "merchant-transaction",
      meta: { layout: "header-navigation" },
      component: MerchantTransaction
    },
    {
      path: "/deals/clients/merchant-plan/:idMerchant",
      name: "merchant-plan",
      meta: { layout: "header-navigation" },
      component: MerchantPlan
    },
    {
      path: "/deals/clients/merchant-docs/:idMerchant",
      name: "merchant-document",
      meta: { layout: "header-navigation" },
      component: MerchantDocs
    },
    {
      path: "/deals/clients/merchant-notes/:idMerchant",
      name: "merchant-notes",
      meta: { layout: "header-navigation" },
      component: MerchantNotes
    },
    {
      path: "/deals/clients/merchant-notification/:idMerchant",
      name: "merchant-notification",
      meta: { layout: "header-navigation" },
      component: MerchantNotification
    },
    {
      path: "/deals/clients/merchant-contact/:idMerchant",
      name: "merchant-contact",
      meta: { layout: "header-navigation" },
      component: MerchantContact
    },
    {
      path: "/deals/clients/merchant-user",
      name: "merchant-user-global",        
      meta: { layout: "header-navigation" },
      component: MerchantUser
    },
    {
      path: "/deals/clients/merchant-user/:idMerchant",
      name: "merchant-user",
      meta: { layout: "header-navigation" },
      component: MerchantUser
    },
    {
      path: "/deals/clients/merchant-trainings/:idMerchant",
      name: "merchant-trainings",
      meta: { layout: "header-navigation" },
      component: MerchantTrainings
    },
    {
      path: "/deals/clients/checking-account/:idMerchant",
      name: "merchant-checking-account",
      meta: { layout: "header-navigation" },
      component: MerchantCheckingAccount
    },
    {
      path:
        "/deals/clients/checking-account/:idMerchant/checking-account-details",
      props: route => ({ query: route.query.initialDate }),
      name: "merchant-checking-account-details",
      meta: { layout: "header-navigation" },
      component: MerchantCheckingAccountDetail
    },
    {
      path: "/deals/pre-clients",
      name: "merchant-preview/",
      meta: { layout: "header-navigation" },
      component: MerchantPreview
    },
    {
      path: "/deals/partners",
      name: "partners",
      meta: { layout: "header-navigation" },
      component: Partners
    },
    {
      path: "/deals/partners/partner-trainings/:idPartner",
      name: "partner-trainings",
      meta: { layout: "header-navigation" },
      component: PartnerTrainings
    },
    {
      path: "/deals/seller-metrics",
      name: "seller-metrics",
      meta: { layout: "header-navigation" },
      component: SellerMetrics
    },
    {
      path: "/deals/negotiation",
      name: "negotiation",
      meta: { layout: "header-navigation" },
      component: Negotiation
    },
    {
      path: "/financial/transaction",
      name: "transaction",
      meta: { layout: "header-navigation" },
      component: Transaction
    },
    {
      path: "/financial/single-sale",
      name: "single-sale",
      meta: { layout: "header-navigation" },
      component: SingleSale
    },
    {
      path: "/deals/merchant-campaigns",
      name: "merchant-campaigns",
      meta: { layout: "header-navigation" },
      component: MerchantCampaigns
    },
    {
      path: "/financial/financial-dashboard",
      name: "financial-dashboard",
      meta: { layout: "header-navigation" },
      component: FinancialDashboard
    },
    {
      path: "/financial/financial-view",
      name: "financial-view",
      meta: { layout: "header-navigation" },
      component: FinancialView
    },
    {
      path: "/relationship/clients-not-transacting",
      name: "clients-not-transacting",
      meta: { layout: "header-navigation" },
      component: MerchantNotTransacting
    },
    {
      path: "/relationship/clients-not-transacting-commercial",
      name: "clients-not-transacting-commercial",
      meta: { layout: "header-navigation" },
      component: MerchantNotTransactingCommercial
    },
    {
      path: "/relationship/customer-service",
      name: "CustomerService",
      meta: { layout: "header-navigation" },
      component: CustomerService
    },
    {
      path: "/relationship/parceiro-atendimento-idParceiro/:idPartner",
      name: "ParceiroAtendimentoIdParceiro",
      meta: { layout: "header-navigation" },
      component: ParceiroAtendimentoIdParceiro
    },
    {
      path: "/relationship/parceiro-atendimento",
      name: "ParceiroAtendimento",
      meta: { layout: "header-navigation" },
      component: ParceiroAtendimento
    },
    {
      path: "/relationship/merchant-contracts",
      name: "merchant-contracts",
      meta: { layout: "header-navigation" },
      component: MerchantContracts
    },
    {
      path: "/relationship/partner-contracts",
      name: "partner-contracts",
      meta: { layout: "header-navigation" },
      component: PartnerContracts
    },
    {
      path: "/relationship/prospect-trainings",
      name: "prospect-treinaings",
      meta: { layout: "header-navigation" },
      component: ProspectTrainings
    },
    {
      path: "/relationship/merchant-trainings",
      name: "merchant-treinaings",
      meta: { layout: "header-navigation" },
      component: MerchantTrainings
    },
    {
      path: "/relationship/partner-trainings",
      name: "partner-treinaings",
      meta: { layout: "header-navigation" },
      component: PartnerTrainings
    },
    {
      path: "/relationship/training-improvements",
      name: "training-improvements",
      meta: { layout: "header-navigation" },
      component: TrainingImprovements
    },
    {
      path: "/relationship/merchant-metrics",
      name: "merchant-metrics",
      meta: { layout: "header-navigation" },
      component: MerchantMetrics
    },
    {
      path: "/relationship/transaction-charge",
      name: "transaction-charge",
      meta: { layout: "header-navigation" },
      component: TransactionCharge
    },
    {
      path: "/relationship/consult-dda",
      name: "consult-dda",
      meta: { layout: "header-navigation" },
      component: ConsultDDA
    },
    {
      path: "/financial/financial-audit",
      name: "financial-audit",
      meta: { layout: "header-navigation" },
      component: FinancialAudit
    },
    {
      path: "/financial/cash-flow",
      name: "cash-flow",
      meta: { layout: "header-navigation" },
      component: CashFlow
    },
    {
      path: "/financial/checking-account-merchants-negative",
      name: "checking-account-merchants",
      meta: { layout: "header-navigation" },
      component: CheckingAccountMerchants
    },
    {
      path: "/financial/checking-account",
      name: "checking-account",
      meta: { layout: "header-navigation" },
      component: CheckingAccount
    },
    {
      path: "/financial/checking-account/checking-account-details",
      props: route => ({ query: route.query.initialDate }),
      name: "checking-account-details",
      meta: { layout: "header-navigation" },
      component: CheckingAccountDetails
    },
    {
      path: "/financial/accounts/payable",
      name: "accountspayable",
      meta: { layout: "header-navigation" },
      component: AccountsPayable
    },
    {
      path: "/financial/accounts/receivable",
      name: "accountsreceivable",
      meta: { layout: "header-navigation" },
      component: AccountsReceivable
    },
    {
      path: "/financial/advance-payment-operations",
      name: "advance-payment-operations",
      meta: { layout: "header-navigation" },
      component: AdvancePaymentOperations
    },
    {
      path: "/financial/transfer-bank-accounts",
      name: "transfer-bank-accounts",
      meta: { layout: "header-navigation" },
      component: TransferBankAccounts
    },
    {
      path: "/financial/advance-payments",
      name: "advance-payments",
      meta: { layout: "header-navigation" },
      component: AdvancePayments
    },
    {
      path: "/financial/payments",
      name: "payments",
      meta: { layout: "header-navigation" },
      component: Payments
    },
    {
      path: "/financial/double-payment",
      name: "double-payment",
      meta: { layout: "header-navigation" },
      component: DoublePayment
    },
    {
      path: "/financial/profits",
      name: "profits",
      meta: { layout: "header-navigation" },
      component: Profits
    },
    {
      path: "/financial/profits/profit/:idMerchant",
      props: route => ({ query: route.query.paymentDate }),
      name: "profit",
      meta: { layout: "header-navigation" },
      component: Profit
    },
    {
      path: "/financial/note-extracts",
      name: "note-extracts",
      meta: { layout: "header-navigation" },
      component: NoteExtracts
    },
    {
      path: "/financial/mensalidade-isencoes",
      name: "mensalidade-isencoes",
      meta: { layout: "header-navigation" },
      component: MensalidadeIsencao
    },
    {
      path: "/financial/lancamentos-manuais",
      name: "lancamentos-manuais",
      meta: { layout: "header-navigation" },
      component: LancamentoManual
    },
    {
      path: "/financial/partner-commissions",
      name: "partner-commissions",
      meta: { layout: "header-navigation" },
      component: PartnerCommissions
    },
    {
      path: "/financial/partner-commissions/partner-commission/:idPartner",
      props: route => ({ query: route.query.initialDate }),
      name: "partner-commission",
      meta: { layout: "header-navigation" },
      component: PartnerCommission
    },
    {
      path: "/financial/note-extract-partners",
      name: "note-extract-partners",
      meta: { layout: "header-navigation" },
      component: NoteExtractPartners
    },
    {
      path: "/financial/transfer-register",
      name: "transfer-register",
      meta: { layout: "header-navigation" },
      component: TransferRegister
    },
    {
      path: "/financial/transferencia-recusada",
      name: "transferencia-recusada",
      meta: { layout: "header-navigation" },
      component: TransferenciaRecusada
    },
    // {
    //   path: "/financial/bank-statement",
    //   name: "bank-statement",
    //   meta: { layout: "header-navigation" },
    //   component: BankStatement
    // },
    {
      path: "/financial/bank-statement/:idAccount",
      name: "bank-statement",
      meta: { layout: "header-navigation" },
      component: BankStatement
    },
    {
      path: "/financial/provider",
      name: "providers",
      meta: { layout: "header-navigation" },
      component: Provider
    },
    {
      path: "/okrs",
      name: "okrs",
      meta: { layout: "header-navigation" },
      component: Okrs
    },
    {
      path: "/administration/calculator",
      name: "calculator",
      meta: { layout: "header-navigation" },
      component: Calculator
    },
    {
      path: "/administration/downloads",
      name: "downloads",
      meta: { layout: "header-navigation" },
      component: Downloads
    },
    {
      path: "/administration/shortener",
      name: "shortener",
      meta: { layout: "header-navigation" },
      component: Shortener
    },
    {
      path: "/administration/signatures",
      name: "signatures",
      meta: { layout: "header-navigation" },
      component: Signatures
    },
    {
      path: "/administration/template-emails",
      name: "template-emails",
      meta: { layout: "header-navigation" },
      component: TemplateEmails
    },
    {
      path: "/administration/template-emails/template-email/:idTemplateEmail",
      props: route => ({ query: route.query.isSeeing }),
      name: "template-email",
      meta: { layout: "header-navigation" },
      component: TemplateEmail
    },
    {
      path: "/administration/emailing",
      name: "emailing",
      meta: { layout: "header-navigation" },
      component: Emailing
    },
    {
      path: "/administration/email",
      name: "email",
      meta: { layout: "header-navigation" },
      component: Email
    },
    {
      path: "/administration/limits",
      name: "limits",
      meta: { layout: "header-navigation" },
      component: Limits
    },
    {
      path: "/administration/parameters",
      name: "parameters",
      meta: { layout: "header-navigation" },
      component: Parameters
    },
    {
      path: "/registrations/fields",
      name: "fields",
      meta: { layout: "header-navigation" },
      component: Fields
    },
    {
      path: "/financial/accounts-receivable-category",
      name: "AccountsReceivableCategory",
      meta: { layout: "header-navigation" },
      component: AccountsReceivableCategory
    },
    {
      path: "/registrations/customer-service-category",
      name: "CustomerServiceCategory",
      meta: { layout: "header-navigation" },
      component: CustomerServiceCategory
    },
    {
      path: "/registrations/contact-category",
      name: "ContactCategory",
      meta: { layout: "header-navigation" },
      component: ContactCategory
    },
    {
      path: "/registrations/parceiro-atendimento-categoria",
      name: "ParceiroAtendimentoCategoria",
      meta: { layout: "header-navigation" },
      component: ParceiroAtendimentoCategoria
    },
    {
      path: "/registrations/categorias-dos-fornecedores",
      name: "CategoriasDosFornecedores",
      meta: { layout: "header-navigation" },
      component: CategoriasDosFornecedores
    },
    {
      path: "/registrations/questions",
      name: "questions",
      meta: { layout: "header-navigation" },
      component: Questions
    },
    {
      path: "/registrations/forms",
      name: "forms",
      meta: { layout: "header-navigation" },
      component: Forms
    },
    {
      path: "/registrations/functionality",
      name: "functionality ",
      meta: { layout: "header-navigation" },
      component: Functionality
    },
    {
      path: "/registrations/answers",
      name: "answers",
      meta: { layout: "header-navigation" },
      component: Answers
    },
    {
      path: "/registrations/register-type",
      name: "register-type",
      meta: { layout: "header-navigation" },
      component: RegisterType
    },
    {
      path: "/registrations/commissions",
      name: "commissions",
      meta: { layout: "header-navigation" },
      component: Commissions
    },
    {
      path: "/registrations/configuration-taxes",
      name: "configuration-taxes",
      meta: { layout: "header-navigation" },
      component: ConfigurationTaxes
    },
    {
      path: "/registrations/composition-fee-type",
      name: "composition-fee-types",
      meta: { layout: "header-navigation" },
      component: CompositionFeeType
    },
    {
      path: "/registrations/services",
      name: "services",
      meta: { layout: "header-navigation" },
      component: Services
    },
    {
      path: "/registrations/service-type",
      name: "service-type",
      meta: { layout: "header-navigation" },
      component: ServiceType
    },
    {
      path: "/registrations/holidays",
      name: "holidays",
      meta: { layout: "header-navigation" },
      component: Holidays
    },
    {
      path: "/registrations/merchant-doc-types",
      name: "merchant-doc-types",
      meta: { layout: "header-navigation" },
      component: MerchantDocType
    },
    {
      path: "/registrations/field-types",
      name: "field-types",
      meta: { layout: "header-navigation" },
      component: FieldTypes
    },
    {
      path: "/registrations/countries",
      name: "countries",
      meta: { layout: "header-navigation" },
      component: Countries
    },
    {
      path: "/registrations/states",
      name: "states",
      meta: { layout: "header-navigation" },
      component: States
    },
    {
      path: "/registrations/cities",
      name: "city",
      meta: { layout: "header-navigation" },
      component: Cities
    },
    {
      path: "/registrations/banks",
      name: "banks",
      meta: { layout: "header-navigation" },
      component: Banks
    },
    {
      path: "/registrations/nichos",
      name: "nichos",
      meta: { layout: "header-navigation" },
      component: Nichos
    },
    {
      path: "/registrations/segmentos",
      name: "segmentos",
      meta: { layout: "header-navigation" },
      component: Segmentos
    },
    {
      path: "/registrations/agencies",
      name: "agencies",
      meta: { layout: "header-navigation" },
      component: Agencies
    },
    {
      path: "/registrations/RegistrationsBankAccount",
      name: "registrations-bank-account",
      meta: { layout: "header-navigation" },
      component: RegistrationsBankAccount
    },
    {
      path: "/registrations/gateways",
      name: "gateways",
      meta: { layout: "header-navigation" },
      component: Gateways
    },
    {
      path: "/registrations/partner-doc-types",
      name: "partner-doc-types",
      meta: { layout: "header-navigation" },
      component: PartnerDocTypes
    },
    {
      path: "/registrations/specie-types",
      name: "specie-types",
      meta: { layout: "header-navigation" },
      component: SpecieTypes
    },
    {
      path: "/financial/accounts-payable-conciliation",
      name: "accounts-payable-conciliation",
      meta: { layout: "header-navigation" },
      component: AccountsPayableConciliation
    },
    {
      path: "/financial/accounts-receivable-conciliation",
      name: "accounts-receivable-conciliation",
      meta: { layout: "header-navigation" },
      component: AccountsReceivableConciliation
    },
    {
      path: "/financial/accounts-payable-category",
      name: "accounts-payable-category",
      meta: { layout: "header-navigation" },
      component: AccountsPayableCategory
    },
    {
      path: "/financial/bank-accounts",
      name: "bank-account",
      meta: { layout: "header-navigation" },
      component: BankAccount
    },
    {
      path: "/financial/bank-conciliation",
      name: "bank-conciliation",
      meta: { layout: "header-navigation" },
      component: BankConciliation
    },
    {
      path: "/financial/pix-nao-identificados",
      name: "pix-nao-identificados",
      meta: { layout: "header-navigation" },
      component: PixDiretoEmConta
    },
    {
      path: "/relationship/merchant-docs",
      name: "merchant-docs",
      meta: { layout: "header-navigation" },
      component: MerchantDocs
    },
    {
      path: "/administration/users",
      name: "users",
      meta: { layout: "header-navigation" },
      component: Users
    },
    {
      path: "/relationship/merchant-solicitations",
      name: "merchant-solicitations",
      meta: { layout: "header-navigation" },
      component: MerchantSolicitations
    },
    {
      path: "/relationship/prospect-histories",
      name: "prospect-histories",
      meta: { layout: "header-navigation" },
      component: ProspectHistories
    },
    {
      path: "/fraud/chargeback-dashboard",
      name: "chargebackDashboard",
      meta: { layout: "header-navigation" },
      component: ChargebackDashboard
    },
    {
      path: "/fraud/transaction-credit-card-refused",
      name: "transaction-credit-card-refused",
      meta: { layout: "header-navigation" },
      component: TransactionCreditCardRefused
    },
    {
      path: "/compliance/alertas-merchant",
      name: "compliance-alertas-merchant",
      meta: { layout: "header-navigation" },
      component: AlertasMerchant
    },
    {
      path: "/fraud/chargeback-dashboard/brand/:idBrand",
      props: route => ({ query: route.query.referenceDate }),
      name: "chargeback-dashboard-brand",
      meta: { layout: "header-navigation" },
      component: ChargebackBrand
    },
    {
      path: "/fraud/chargeback",
      name: "chargeback",
      meta: { layout: "header-navigation" },
      component: Chargeback
    },
    {
      path: "/fraud/chargebacks-marketplace-dashboard",
      name: "chargebacks-marketplace-dashboard",
      meta: { layout: "header-navigation" },
      component: ChargebacksMarketplaceDashboard
    },
    {
      path: "/fraud/chargebacks-marketplace/:idMerchantRoot/list",
      props: route => ({ query: route.query }),
      name: "chargebackMarketplace",
      meta: { layout: "header-navigation" },
      component: ChargebackMarketplace
    },
    {
      path: "/fraud/emailage",
      name: "emailage",
      meta: { layout: "header-navigation" },
      component: Emailage
    },
    {
      path: "/fraud/SuspectTransaction",
      name: "suspectTransaction",
      meta: { layout: "header-navigation" },
      component: SuspectTransaction
    },
    {
      path: "/fraud/BlockList",
      name: "BlockLists",
      meta: { layout: "header-navigation" },
      component: BlockLists
    },
    {
      path: "/fraud/merchantLimits",
      name: "MerchantLimits",
      meta: { layout: "header-navigation" },
      component: MerchantLimits
    },
    {
      path: "/settings/areas",
      name: "areas",
      meta: { layout: "header-navigation" },
      component: Areas
    },
    {
      path: "/settings/access-actions",
      name: "access-actions",
      meta: { layout: "header-navigation" },
      component: AccessActions
    },
    {
      path: "/settings/access-controls",
      name: "access-controls",
      meta: { layout: "header-navigation" },
      component: AccessControls
    },
    {
      path: "/settings/access-permissions",
      name: "access-permissions",
      meta: { layout: "header-navigation" },
      component: AccessPermissions
    },
    {
      path:
        "/administration/access-permissions/access-permission/:idUserProfileInternal",
      props: route => ({ query: route.query.isSeeing }),
      name: "access-permission",
      meta: { layout: "header-navigation" },
      component: AccessPermission
    },
    {
      path: "/registrations/brand",
      name: "brand",
      meta: { layout: "header-navigation" },
      component: Brand
    },
    {
      path: "/registrations/documents",
      name: "documents",
      meta: { layout: "header-navigation" },
      component: Documents
    },
    {
      path: "/relationship/partner-docs",
      name: "partner-docs",
      meta: { layout: "header-navigation" },
      component: PartnerDocs
    },
    {
      path: "/administration/operators",
      name: "operators",
      meta: { layout: "header-navigation" },
      component: Operators
    },
    {
      path: "/deals/OperadoresDetalhes/:idOperator/:modo",
      name: "OperadoresDetalhes",
      props: true,
      meta: { layout: "header-navigation" },
      component: OperadoresDetalhes
    },
    {
      path: "/administration/healthchecks",
      name: "healthchecks",
      meta: { layout: "header-navigation" },
      component: HealthChecks
    },
    {
      path: "/administration/watcher-type",
      name: "watcher-type",
      meta: { layout: "header-navigation" },
      component: WatcherType
    },
    {
      path: "/administration/watchers",
      name: "watchers",
      meta: { layout: "header-navigation" },
      component: Watchers
    },
    {
      path: "/administration/tickets",
      name: "tickets",
      meta: { layout: "header-navigation" },
      component: Tickets
    },
    {
      path: "/administration/change-management",
      name: "change-management",
      meta: { layout: "header-navigation" },
      component: ChangeManagement
    },
    {
      path: "/user-profile",
      name: "user-profile",
      meta: { layout: "header-navigation" },
      component: UserProfile
    },
    {
      path: "/change-password",
      name: "change-password",
      meta: { layout: "header-navigation" },
      component: ChangePassword
    },
    {
      path: "/change-access",
      name: "change-access",
      meta: { layout: "header-navigation" },
      component: ChangeAccess
    },
    {
      path: "/errors",
      name: "errors",
      meta: { layout: "default" },
      component: Errors
    },
    {
      path: "*",
      redirect: "/errors"
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router.js